import { Dispatch, SetStateAction, useEffect } from 'react';
import { useAppDispatch } from 'app/hooks';
import { useSearchParams } from 'react-router-dom';

import { analyzerChanged } from '../analyzerSlice';
import { snapshotChanged } from 'features/snapshots/snapshotsSlice';

interface Props {
  setActiveTab: Dispatch<SetStateAction<number>>;
}

export const useParseQueryParams = ({ setActiveTab }: Props) => {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!searchParams.get('analyzerId')) return;
    const analyzerId = searchParams.get('analyzerId');
    const snapshotId = searchParams.get('snapshotId');
    const recordingMode = searchParams.get('recordingMode');

    dispatch(analyzerChanged(Number(analyzerId)));
    dispatch(snapshotChanged(Number(snapshotId)));

    if (Boolean(recordingMode)) {
      setActiveTab(2);
    }
  }, [dispatch, searchParams, setActiveTab]);
};
